import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';
import PubSub from 'pubsub-js';

function FilterTag({ 
    FilterTags, 
    Loading,
    Roletype,
    dist_id,
    Rolename,
    wh_Id,
    df,
    dt,
    dashboardName,
    startDate,
    endDate,
    handeChangefiltertag,
    handlechangea
}) {
    const [filterTagList, setFilterTagList] = useState([]);
    const [filterMatchedTagList, setFilterMatchedTagList] = useState([]);
    const [loading, setLoading] = useState(Loading);
    const [resetDisabled, setResetDisabled] = useState(false);

    useEffect(() => {
        if (FilterTags != null && FilterTags != '' && FilterTags != undefined && FilterTags != "null") {
            bindFilteredTag(Roletype, dist_id, Rolename, wh_Id, df, dt, FilterTags);
        }
    }, []);

    useEffect(() => {
        if (FilterTags != null && FilterTags != '' && FilterTags != undefined && FilterTags != "null") {
            setFilterTagList([]);
            setResetDisabled(true);
            bindFilteredTag(Roletype, dist_id, Rolename, wh_Id, df, dt, FilterTags);
        } else {
            // FilterTags became empty (e.g. after reset) — clear immediately so badges disappear
            setFilterTagList([]);
            setFilterMatchedTagList([]);
            setResetDisabled(false);
        }
    }, [FilterTags]);

    const bindFilteredTag = async (role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) => {
        try {
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson },
                body: JSON.stringify({ role, distributor_UserId, name, wholesalerid, datefrom, dateto })
            };
            
            const response = await fetch(`/api/Filter/getFilterMatchingTag`, requestOptions);
            const text = await response.text();
            const apidata = text && JSON.parse(text);
            
            try {
                if (apidata.length > 0) {
                    setResetDisabled(false);
                    setFilterTagList(JSON.parse(FilterJson));
                    setFilterMatchedTagList(apidata);
                }
            } catch (error) {
                try {
                    setFilterTagList(FilterJson);
                    setFilterMatchedTagList(apidata);
                } catch (error) {
                }
            }
        } catch (error) {
        }
    };

    const handleRemoveTag = (e, nodename, nodevalue) => {
        try {
            let CreatedJson = '';
            try {
                let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
                CreatedJson = JSON.stringify(ExistJson);
                let ItemIndex = ExistJson[nodename].indexOf(nodevalue);

                if (ItemIndex > -1) {
                    ExistJson[nodename].splice(ItemIndex, 1);
                    if (ExistJson[nodename].length == 0) {
                        delete ExistJson[nodename];
                    }
                } else if (nodename == "PhZip" || nodename == "PrZip") {
                    let ItemIndex = ExistJson[nodename].indexOf(nodevalue.replace('-', ''));
                    ExistJson[nodename].splice(ItemIndex, 1);
                    if (ExistJson[nodename].length == 0) {
                        delete ExistJson[nodename];
                    }
                }

                try {
                    const updatedFilterEmpty = JSON.stringify(ExistJson) == "{}";
                    if (updatedFilterEmpty) {
                        localStorage.setItem('Advance_Filter', null);
                    } else {
                        localStorage.setItem('Advance_Filter', JSON.stringify(ExistJson));
                    }
                    let newDate = new Date();
                    localStorage.setItem('Filter_Last_Update_Time', newDate);
                    localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);

                    // Immediately update local state so the badge disappears without waiting for API round-trip
                    if (updatedFilterEmpty) {
                        setFilterTagList([]);
                        setFilterMatchedTagList([]);
                    } else {
                        setFilterTagList(ExistJson);
                        setFilterMatchedTagList(prev => prev.filter(m =>
                            !(m.tableType === nodename && m.value === nodevalue)
                        ));
                    }

                    // If removing PCN:HD while on a non-Total tab, signal the page to go back to Total
                    const currentHDType = localStorage.getItem('Updated_HD_Type');
                    if (currentHDType && currentHDType !== 'totalpaid' && nodename === 'PBM' && nodevalue === 'HD') {
                        localStorage.setItem('Prev_HD_Type', currentHDType);
                        localStorage.setItem('Updated_HD_Type', 'totalpaid');
                        let newDate2 = new Date();
                        localStorage.setItem('Filter_Last_Update_Time', newDate2);
                        PubSub.publish('PBM', 'HD');
                    }
                    handlechangea(e);
                } catch (error) {
                }
            } catch (error) {
            }
        } catch (error) {
        }
    };

    const handleResetButton = (e) => {
        try {
            PubSub.publish('PBM', 'HD');
            setLoading(false);

            // Immediately clear badges — mirrors Bridge's $(".filtered_tag_dashboard").hide()
            setFilterTagList([]);
            setFilterMatchedTagList([]);

            let CreatedJson = '';
            let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            CreatedJson = JSON.stringify(ExistJson);
            localStorage.setItem('Advance_Filter', null);

            let newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate);
            localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);

            const LocalHDType = localStorage.getItem('Updated_HD_Type');
            localStorage.setItem('Prev_HD_Type', LocalHDType);
            localStorage.setItem('Updated_HD_Type', 'totalpaid');

            let newDate1 = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate1);
            handlechangea(e);
        } catch (error) {
        }
    };

    const getTagTypeFullName = (stext) => {
        const tagNames = {
            'PBM': 'PCN',
            'PhBin': 'BIN',
            'DistributorName': 'Distributor Name',
            'PhCity': 'Pharmacy City',
            'PrCity': 'Prescriber City',
            'PhState': 'Pharmacy State',
            'PrState': 'Prescriber State',
            'PhZip': 'Pharmacy ZIP',
            'PrZip': 'Prescriber ZIP',
            'PharmacyName': 'Pharmacy Name',
            'GroupNumber': 'Group Number',
            'WholesalerName': 'Wholesaler Name',
            'DrugName': 'Drug Name',
            'Prescriber': 'Prescriber Name',
            'Override': 'Override',
            'PhGPrefix': 'Group Prefix',
            'Group Prefix': 'Group Prefix'
        };
        return tagNames[stext] || stext;
    };

    const renderFilterTags = () => {
        const tagCount = Object.keys(filterTagList).length;

        if (tagCount > 0) {
            return (
                <div className='filtered_tag_selected tag-available'>
                    <div className="filtered_content">
                        <div className="flex flex-wrap items-center gap-2">
                            {Object.keys(filterTagList).map((key) => {
                                try {
                                    if (filterMatchedTagList.filter((d) => d["tableType"] == key).length > 0) {
                                        let KeyValue = filterMatchedTagList.filter(m1 => m1.tableType == key);
                                        return KeyValue.map((k1, ik) => {
                                            try {
                                                const isActive = k1.hasData == "True";
                                                return (
                                                    <Badge
                                                        key={`${key}-${k1.value}-${ik}`}
                                                        className={[
                                                            "h-6 gap-1 pr-1 select-none transition-colors",
                                                            isActive
                                                                ? "bg-accent text-white border-accent hover:bg-accent"
                                                                : "bg-muted text-primary/50 border-primary/20 hover:bg-muted"
                                                        ].join(" ")}
                                                        variant="outline"
                                                    >
                                                        <span>{getTagTypeFullName(key)}: {k1.value}</span>
                                                        <Button
                                                            type="button"
                                                            variant="ghost"
                                                            size="icon"
                                                            onClick={(e) => handleRemoveTag(e, key, k1.value)}
                                                            className="ml-0.5 h-3 w-3 min-w-0 rounded-full p-0 hover:bg-black/20 hover:text-current [&_svg]:size-3"
                                                        >
                                                            <X />
                                                        </Button>
                                                    </Badge>
                                                );
                                            } catch (error) {
                                                return null;
                                            }
                                        });
                                    } else {
                                        return filterTagList[key].map((e1, i1) => (
                                            <Badge
                                                key={`${key}-${e1}-${i1}`}
                                                className="h-6 gap-1 pr-1 select-none bg-muted text-primary/50 border-primary/20 hover:bg-muted"
                                                variant="outline"
                                            >
                                                <span>{getTagTypeFullName(key)}: {e1}</span>
                                                <Button
                                                    type="button"
                                                    variant="ghost"
                                                    size="icon"
                                                    onClick={(e) => handleRemoveTag(e, key, e1)}
                                                    className="ml-0.5 h-3 w-3 min-w-0 rounded-full p-0 hover:bg-black/20 hover:text-current [&_svg]:size-3"
                                                >
                                                    <X />
                                                </Button>
                                            </Badge>
                                        ));
                                    }
                                } catch (error) {
                                    return null;
                                }
                            })}

                            {filterMatchedTagList.length > 0 && (
                                <Button
                                    disabled={resetDisabled}
                                    onClick={handleResetButton}
                                    className="reset_filter_tag_button_event h-6 px-2 text-xs font-medium bg-primary text-white hover:bg-primary disabled:opacity-40"
                                    size="sm"
                                >
                                    Reset
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        // Fallback to localStorage if filterTagList is empty
        const LocalFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
        if (LocalFilterJson != null && Object.keys(LocalFilterJson).length > 0) {
            return (
                <div className='filtered_tag_selected tag-available'>
                    <div className="filtered_content">
                        <div className="flex flex-wrap items-center gap-2">
                            {Object.keys(LocalFilterJson).map((key, index) => {
                                return LocalFilterJson[key].map((e1, i1) => (
                                    <Badge
                                        key={`${index}-${i1}`}
                                        className="h-6 gap-1 pr-1 select-none bg-muted text-primary/50 border-primary/20 hover:bg-muted"
                                        variant="outline"
                                    >
                                        <span>{getTagTypeFullName(key)}: {e1}</span>
                                        <Button
                                            type="button"
                                            variant="ghost"
                                            size="icon"
                                            onClick={(e) => handleRemoveTag(e, key, e1)}
                                            className="ml-0.5 h-3 w-3 min-w-0 rounded-full p-0 hover:bg-black/20 hover:text-current [&_svg]:size-3"
                                        >
                                            <X />
                                        </Button>
                                    </Badge>
                                ));
                            })}

                            <Button
                                disabled={resetDisabled}
                                onClick={handleResetButton}
                                className="reset_filter_tag_button_event h-6 px-2 text-xs font-medium bg-primary text-white hover:bg-primary disabled:opacity-40"
                                size="sm"
                            >
                                Reset
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className='filtered_tag_selected'>
                <div className="filtered_content">
                    <div className="filtered_adjust"></div>
                </div>
            </div>
        );
    };

    return renderFilterTags();
}

export default FilterTag;
